import TeamsTable from './TeamsTable';

export default TeamsTable;
